/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Area_M2Inputs */

const cs_form_area_m2 = /** @type {(inputs: Form_Area_M2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const en_form_area_m2 = /** @type {(inputs: Form_Area_M2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

/**
* | output |
* | --- |
* | "m²" |
*
* @param {Form_Area_M2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_area_m2 = /** @type {((inputs?: Form_Area_M2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Area_M2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_area_m2(inputs)
	return cs_form_area_m2(inputs)
});